import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { setUserSession } from "../Utils/Common";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { APP_KEY, API_URL } from "../config";
import Footer from "./Footer/Footer";
import Spinner from "./spinner";
import OtpInput from "react-otp-input";
import { Button, Divider, Modal } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import { APP_INFO } from "../Utils/appConstants";
import AdvertiseSlider from "./AdvertiseSlider";
import ForgetMpin from "./ForgetMpin";
import { getFCMToken, onMessageListener } from "../firebase";
import { getRequest, postRequest } from "../Utils/AppApi";
import QRCode from "react-qr-code";

import {
  UPDATE_NEW_PASSWORD,
  UPDATE_NEW_PASSWORD_SAVE,
  FORGET_MPIN_NUMBER,
  GST_IN_VERIFY,
  MOBILE_SEND_OTP,
  MOBILE_SEND_VERFIY,
  CHANGE_PASSWORD,
  SAVE_MPIN_NUMBER,
} from "./../Utils/appConstants";

function Login(props) {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [appInfo, setAppInfo] = useState("");
  const [userAgent, setUserAgent] = useState(null);
  const [loginData, setLoginData] = useState(null);
  const [isOTPModal, setOTPModal] = useState(false);
  const [isChangePasswordOTPModal, setChangePasswordOTPModal] = useState(false);
  const [isMpinModal, setMpinModal] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [isEye, setEye] = useState("fas fa-eye-slash");
  const [OTPShowMessage, setOTPShowMessage] = useState("");
  const [otpCode, setOtpCode] = useState(0);
  const username = useFormInput("");
  const password = useFormInput("");
  const [timer, setTimer] = useState(120);
  const [mPinNumber, setmPinNumber] = useState("");
  const [isMpinChangeModal, setMpinChangeModal] = useState(false);
  const [strength, setStrength] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [isOtpNumber, setOtpNumber] = useState(false);
  const [isChangePassword, setChangePassword] = useState(false);
  const [isLowUpper, setLowUpper] = useState(false);
  const [isPassNumber, setPassNumber] = useState(false);
  const [isSpecial, setSpecial] = useState(false);
  const [isEightPassword, setEightPassword] = useState(false);
  const [isConfirmPassword, setConfirmPassword] = useState(null);
  const [isNewPassword, setNewPassword] = useState("");
  const [isForgotPasswordModal, setForgotPasswordModal] = useState("");
  const [isPanNumber, setPannumber] = useState(null);
  const [getDataField, setDataField] = useState({});
  const [isUserId, setuserId] = useState(null);
  const [fcmToken, setFcmToken] = useState(null);

  // 👁️ Single source of truth for M-PIN visibility
  const [showMpin, setShowMpin] = useState(false);

  // Brand Colors
  const primaryRed = '#C9262C';
  const accentGold = '#FFDD09';
  const vibrantOrange = '#FF8C00';
  const successGreen = '#02A650';

  const countDown = () => {
    setLoading(true);
    let secondsToGo = 3;
    const timer = setInterval(() => { secondsToGo -= 1; }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      window.location.reload();
    }, secondsToGo * 1000);
  };

  const headers = {
    headers: { appKey: APP_KEY, "Content-Type": "application/json" },
  };

  const redirectJoinUs = () => history.push({ pathname: "/joinus" });

  const degreesToRadians = (degrees) => degrees * (Math.PI / 180);

  const onChangeValue = (event) => {
    const { name, value } = event.target;
    setDataField({ ...getDataField, [name]: value });
  };

  const calculateHaversine = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = degreesToRadians(lat2 - lat1);
    const dLon = degreesToRadians(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  function handleMpin() {
    setLoading(true);
    axios.post(`${API_URL}/users/loginUsername`, { username: username.value, password: password.value, deviceType: "w" }, headers)
      .then(async (data) => {
        setLoading(false);
        if (data.data.success === true) {
          if (data.data.isOldPassword) { setChangePassword(true); return; }
          if (data.data.isMpin) {
            setShowMpin(false);     // always open masked
            setMpinModal(true);
          } else { setMpinChangeModal(true); }
        } else { setMpinModal(false); toast.error(data.data.message); }
      })
      .catch((error) => { setLoading(false); setMpinModal(false); toast.error(error?.response?.data?.message); });
  }

  const fetchIpLocationFallback = async () => {
    try {
      const res = await axios.get("https://ipapi.co/json/");
      if (res.data?.latitude && res.data?.longitude) return { latitude: res.data.latitude, longitude: res.data.longitude, source: "IP" };
    } catch (e) { console.log("IP fallback error", e); }
    return { latitude: null, longitude: null, source: "NONE" };
  };

  const handleFallbackLocation = async () => {
    const fallback = await fetchIpLocationFallback();
    let latitude = fallback.latitude, longitude = fallback.longitude;
    if (!latitude || !longitude) {
      const cached = JSON.parse(localStorage.getItem("last_location"));
      if (cached) { latitude = cached.latitude; longitude = cached.longitude; }
    }
    if (!latitude || !longitude) { latitude = 20.5937; longitude = 78.9629; }
    handleLogin({ latitude, longitude, macAddress: userAgent, devicetype: "W" });
  };

  function handleLocationClick() {
    setLoading(true);
    if (!navigator.geolocation) { handleFallbackLocation(); return; }
    navigator.geolocation.getCurrentPosition(success, async () => { await handleFallbackLocation(); }, { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 });
  }

  const success = async (position) => {
    let latitude = position?.coords?.latitude, longitude = position?.coords?.longitude;
    if (!latitude || !longitude || (latitude === 0 && longitude === 0)) {
      try { const res = await axios.get("https://ipapi.co/json/"); latitude = res.data.latitude; longitude = res.data.longitude; } catch (e) { latitude = 0; longitude = 0; }
    }
    localStorage.setItem("last_location", JSON.stringify({ latitude, longitude }));
    if (username.value && password.value) {
      handleLogin({ latitude, longitude, macAddress: userAgent, devicetype: "W" });
    } else { toast.error("Please enter your username and password"); }
  };

  const handleLogin = (data) => {
    setLoading(true);
    if (isOTPModal && !otpCode) { setLoading(false); toast.error("Please enter OTP"); return false; }
    axios.post(`${API_URL}/users/login`, {
      username: username.value, password: password.value,
      macAddress: data.macAddress, devicetype: data.devicetype,
      latitude: data.latitude, longitude: data.longitude,
      otpCode: otpCode, mPin: mPinNumber, fcmToken: fcmToken,
    }, headers)
      .then(async (data) => {
        setLoading(false);
        if (data.data.success === true && data.data.otpcheck === true) { setOTPShowMessage(data.data.message); setOTPModal(true); }
        else if (data.data.otpcheck === true && !data.data.success) { toast.error(data.data.message); setOTPModal(true); }
        else if (data.data.success === true) { setUserSession(data.data.data.token, data.data); setOTPModal(false); setOtpCode(0); setLoginData(data.data.data); countDown(); }
        else { toast.error(data.data.message); }
      })
      .catch((error) => { setLoading(false); toast.error(error?.response?.data?.message); });
  };

  const getAppInfo = async () => {
    getRequest(`${API_URL}/appinfo`).then(async (data) => {
      if (data) { setAppInfo(data); reactLocalStorage.set(APP_INFO, JSON.stringify(data), true); }
    }).catch(() => {});
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const checkStrength = (password) => {
    let strength = 0;
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) { setLowUpper(true); strength += 1; } else { setLowUpper(false); }
    if (password.match(/([0-9])/)) { setPassNumber(true); strength += 1; } else { setPassNumber(false); }
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) { setSpecial(true); strength += 1; } else { setSpecial(false); }
    if (password.length > 7) { setEightPassword(true); strength += 1; } else { setEightPassword(false); }
    setStrength(strength);
  };
  const getStrengthColor = () => strength < 2 ? "progress-bar bg-danger" : strength === 3 ? "progress-bar bg-warning" : "progress-bar bg-success";
  const getStrengthPercentage = () => (strength / 4) * 100;

  const FormValidateChangePassword = () => {
    if (!username.value?.trim()) { toast.error("User Id is required"); return false; }
    if (username.value.length !== 9) { toast.error("User Id is not valid"); return false; }
    if (!isNewPassword) { toast.error("New password is required"); return false; }
    if (strength < 4) { toast.error("Password strength is not good"); return false; }
    if (!isConfirmPassword) { toast.error("Confirm password is required"); return false; }
    if (isConfirmPassword !== isNewPassword) { toast.error("Confirm password did not match"); return false; }
    return true;
  };

  const checkisUserId = async () => {
    const response = await postRequest(FORGET_MPIN_NUMBER, { username: username.value, pancard: isPanNumber }, history);
    if (response.success === true) { setChangePassword(true); } else { toast.error(response.message); }
  };

  const handleChangePasswordSendOtp = () => {
    if (FormValidateChangePassword()) {
      postRequest(UPDATE_NEW_PASSWORD, { userName: username.value, newPassword: isConfirmPassword }, history)
        .then((response) => {
          if (response.success === true) { toast.success(response.message); setChangePassword(false); setChangePasswordOTPModal(true); setForgotPasswordModal(false); }
          else { toast.error(response.message); }
        });
    }
  };

  const handleChangePasswordSubmit = () => {
    if (FormValidateChangePassword()) {
      postRequest(UPDATE_NEW_PASSWORD_SAVE, { userName: username.value, newPassword: isNewPassword, otp: otpCode }, history)
        .then((response) => {
          if (response.success === true) { toast.success(response.message); setChangePasswordOTPModal(false); }
          else { toast.error(response.message); }
        });
    }
  };

  const handleHideModal = () => { setOtpNumber(false); setChangePassword(false); setConfirmPassword(null); };
  const redirectForgetUserIDPage = () => history.push({ pathname: "/forget-userid" });
  const togglePassword = () => {
    if (passwordType === "password") { setPasswordType("text"); setEye("fas fa-eye"); }
    else { setPasswordType("password"); setEye("fas fa-eye-slash"); }
  };

  const handleMpinValueChange = (value) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    setmPinNumber(numericValue);
  };

  const changePassword = (value) => { checkStrength(value); setNewPassword(value); };

  // 👁️ Toggle M-PIN visibility
  const toggleMpinVisibility = () => setShowMpin((prev) => !prev);

  useEffect(() => {
    const enablePush = async () => {
      let permission = Notification.permission;
      if (permission === "default") permission = await Notification.requestPermission();
      if (permission === "granted") { const token = await getFCMToken(); setFcmToken(token); }
    };
    enablePush();
    onMessageListener().then((payload) => { new Notification(payload.notification.title, { body: payload.notification.body }); });
  }, []);

  useEffect(() => { if (isChangePassword) { setNewPassword(""); setConfirmPassword(""); setShowPassword(false); } }, [isChangePassword]);
  useEffect(() => { getAppInfo(); setUserAgent(navigator.platform + "-" + navigator.userAgent); }, []);
  useEffect(() => {
    if (timer) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      if (timer === 0) { clearInterval(interval); setOTPModal(false); window.location.reload(); }
      return () => clearInterval(interval);
    }
  }, [timer]);

  if (isLoading && !isOTPModal && !isMpinModal) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(160deg, #FFFBEB, #FFF8F5, #FFFBEB)' }}>
        <Spinner />
      </div>
    );
  }

  // Style constants
  const pageStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #FFFBEB 0%, #FFF8F5 25%, #FFFBEB 50%, #F8F9FF 75%, #FFFBEB 100%)',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  };

  const topBarStyle = {
    background: 'rgba(255,255,255,0.95)',
    backdropFilter: 'blur(20px)',
    borderBottom: `2px solid ${accentGold}`,
    padding: '10px 0',
    position: 'sticky',
    top: 0,
    zIndex: 100
  };

  const inputStyle = {
    width: '100%',
    padding: '14px 18px',
    marginBottom: '12px',
    borderRadius: '12px',
    border: '2px solid #E5E7EB',
    fontSize: '15px',
    outline: 'none',
    backgroundColor: '#FAFBFC',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    transition: 'all 0.3s ease',
    color: '#1A1A2E'
  };

  const inputWithIconStyle = {
    ...inputStyle,
    padding: '14px 50px 14px 18px'
  };

  const btnPrimaryStyle = {
    width: '100%',
    padding: '14px 24px',
    background: `linear-gradient(135deg, ${primaryRed} 0%, #E8454B 100%)`,
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontWeight: 700,
    fontSize: '15px',
    cursor: 'pointer',
    boxShadow: '0 8px 25px rgba(201,38,44,0.3)',
    transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    letterSpacing: '0.5px'
  };

  const btnOutlineStyle = {
    ...btnPrimaryStyle,
    background: '#fff',
    color: primaryRed,
    border: `2px solid ${primaryRed}`,
    boxShadow: 'none'
  };

  const btnSecondaryOutline = {
    width: '100%',
    padding: '13px 24px',
    background: '#FFF5F5',
    color: primaryRed,
    border: `2px solid ${primaryRed}30`,
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px'
  };

  const handleInputFocus = (e) => {
    e.target.style.borderColor = primaryRed;
    e.target.style.backgroundColor = '#fff';
    e.target.style.boxShadow = '0 0 0 3px rgba(201,38,44,0.08)';
  };

  const handleInputBlur = (e) => {
    e.target.style.borderColor = '#E5E7EB';
    e.target.style.backgroundColor = '#FAFBFC';
    e.target.style.boxShadow = 'none';
  };

  const handleBtnHover = (e, isPrimary) => {
    if (isPrimary) {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = '0 15px 35px rgba(201,38,44,0.45)';
    } else {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.background = primaryRed;
      e.target.style.color = '#fff';
      e.target.style.boxShadow = '0 10px 30px rgba(201,38,44,0.3)';
    }
  };

  const handleBtnLeave = (e, isPrimary) => {
    if (isPrimary) {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = '0 8px 25px rgba(201,38,44,0.3)';
    } else {
      e.target.style.transform = 'translateY(0)';
      e.target.style.background = '#fff';
      e.target.style.color = primaryRed;
      e.target.style.boxShadow = 'none';
    }
  };

  const otpInputStyle = {
    width: '45px',
    height: '52px',
    fontSize: '1.5rem',
    borderRadius: '10px',
    border: '2px solid #E5E7EB',
    textAlign: 'center',
    outline: 'none',
    fontWeight: 700
  };

  return (
    <div style={pageStyle}>
      {/* Top Bar */}
      <div style={topBarStyle}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <a href="/"><img src="../../logo.png" alt="SR PAY" style={{ height: '38px' }} /></a>
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            <a href={`https://wa.me/${appInfo.helpNumber}`} target="_blank" rel="noreferrer"
              style={{ color: '#4A4A6A', textDecoration: 'none', fontSize: '14px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="fab fa-whatsapp" style={{ color: '#25D366', fontSize: '16px' }}></i> {appInfo.helpNumber}
            </a>
            <a href={`mailto:${appInfo.email}`}
              style={{ color: '#4A4A6A', textDecoration: 'none', fontSize: '14px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="fas fa-envelope" style={{ color: primaryRed, fontSize: '14px' }}></i> {appInfo.email}
            </a>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '30px 20px', minHeight: 'calc(100vh - 140px)' }}>
        <div style={{ background: '#fff', borderRadius: '20px', boxShadow: '0 15px 50px rgba(0,0,0,0.08)', border: '1px solid #E5E7EB', width: '100%', maxWidth: '900px', overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>

            {/* LEFT PANEL */}
            <div style={{
              background: `linear-gradient(160deg, ${primaryRed} 0%, ${vibrantOrange} 100%)`,
              padding: '45px 35px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              textAlign: 'center'
            }}>
              <div style={{ background: '#fff', padding: '20px', borderRadius: '14px', marginBottom: '24px' }}>
                <img src="../../logo.png" alt="SR PAY" style={{ height: '50px' }} />
              </div>

              <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '10px', color: '#fff' }}>
                Your Trusted Service Partner
              </h2>
              <p style={{ fontSize: '13px', opacity: 0.9, marginBottom: '28px', lineHeight: 1.5, color: '#fff' }}>
                Mobile Recharge • Bill Payments • Insurance • Travel & More
              </p>

              <div style={{ background: '#fff', padding: '14px', borderRadius: '12px', marginBottom: '10px' }}>
                <QRCode value="https://play.google.com/store/apps/details?id=com.srpaypartner" size={110} level="M" />
              </div>
              <p style={{ fontSize: '11px', opacity: 0.8, color: '#fff', marginBottom: '10px' }}>Scan to Download App</p>
              
              <AdvertiseSlider />
            </div>

            {/* RIGHT PANEL */}
            <div style={{ padding: '40px 35px', background: '#fff' }}>
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: primaryRed, marginBottom: '4px' }}>Welcome Back 👋</h2>
                <p style={{ color: '#6B7280', fontSize: '13px' }}>Login to your account to continue</p>
              </div>

              {/* User ID */}
              <input
                type="text"
                {...username}
                placeholder="👤 User ID"
                style={inputStyle}
                disabled={isMpinModal}
                maxLength={15}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
              />

              {/* Password */}
              <div style={{ position: 'relative' }}>
                <input
                  type={passwordType}
                  {...password}
                  placeholder="🔒 Password"
                  style={inputWithIconStyle}
                  disabled={isMpinModal}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                />
                <div
                  onClick={togglePassword}
                  style={{
                    position: 'absolute',
                    right: '16px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#9CA3AF',
                    fontSize: '16px'
                  }}
                >
                  <i className={isEye}></i>
                </div>
              </div>

              {/* M-PIN Modal */}
              {isMpinModal && (
                <Modal
                  width={480}
                  title={<span style={{ fontWeight: 700 }}>🔐 M-PIN Verification</span>}
                  open={isMpinModal}
                  footer={false}
                  maskClosable={false}
                  onCancel={() => {
                    setMpinModal(false);
                    setmPinNumber("");
                    setShowMpin(false);
                  }}
                >
                  <div style={{ padding: "16px 0", textAlign: "center" }}>
                    <p style={{ color: "#6B7280", marginBottom: "20px", fontSize: "14px" }}>
                      Enter your 6-digit secure M-PIN
                    </p>

                    {/* M-PIN Input — mask + CSS lockstep toggle */}
                    <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "12px" }}>
                      <OtpInput
                        value={mPinNumber || ""}
                        onChange={handleMpinValueChange}
                        numInputs={6}
                        isInputNum={true}
                        shouldAutoFocus={true}
                        mask={showMpin ? "" : "*"}
                        separator={<span style={{ width: "8px" }} />}
                        inputStyle={{
                          ...otpInputStyle,
                          width: "45px",
                          height: "52px",
                          fontSize: "20px",
                          textAlign: "center",
                          WebkitTextSecurity: showMpin ? "none" : "disc",
                          textSecurity: showMpin ? "none" : "disc",
                        }}
                      />
                    </div>

                    {/* 👁️ Show / Hide toggle */}
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={toggleMpinVisibility}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleMpinVisibility();
                        }
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        margin: "0 auto 22px",
                        padding: "7px 16px",
                        borderRadius: "20px",
                        background: showMpin ? "#FFF5F5" : "#F3F4F6",
                        color: showMpin ? primaryRed : "#4B5563",
                        border: `1px solid ${showMpin ? `${primaryRed}40` : "#E5E7EB"}`,
                        fontSize: "13px",
                        fontWeight: 600,
                        cursor: "pointer",
                        userSelect: "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <i className={showMpin ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                      {showMpin ? "Hide M-PIN" : "View M-PIN"}
                    </div>

                    {/* Verify */}
                    <button
                      onClick={() => {
                        if (!mPinNumber || mPinNumber.length !== 6) {
                          toast.error("Please enter a valid 6-digit M-PIN");
                          return;
                        }
                        handleLocationClick();
                      }}
                      disabled={isLoading}
                      style={{
                        ...btnPrimaryStyle,
                        opacity: isLoading ? 0.7 : 1,
                        cursor: isLoading ? "not-allowed" : "pointer",
                      }}
                      onMouseOver={(e) => { if (!isLoading) handleBtnHover(e, true); }}
                      onMouseOut={(e) => { if (!isLoading) handleBtnLeave(e, true); }}
                    >
                      {isLoading ? "🔄 Verifying..." : "✅ Verify & Login"}
                    </button>

                    {/* Forgot M-PIN */}
                    <button
                      onClick={() => {
                        setMpinModal(false);
                        setmPinNumber("");
                        setShowMpin(false);
                        setMpinChangeModal(true);
                      }}
                      style={btnSecondaryOutline}
                      onMouseOver={(e) => {
                        e.target.style.background = "#FFF0F0";
                        e.target.style.borderColor = primaryRed;
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = "#FFF5F5";
                        e.target.style.borderColor = `${primaryRed}30`;
                      }}
                    >
                      🔄 Forget M-PIN
                    </button>
                  </div>
                </Modal>
              )}

              {/* Continue */}
              <button
                onClick={handleMpin}
                style={{ ...btnPrimaryStyle, marginTop: '6px' }}
                onMouseOver={(e) => handleBtnHover(e, true)}
                onMouseOut={(e) => handleBtnLeave(e, true)}
              >
                🚀 Continue {isLoading ? "..." : ""}
              </button>

              {/* Links */}
              <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: '#6B7280', lineHeight: 2 }}>
                <span onClick={() => setForgotPasswordModal(true)} style={{ color: primaryRed, cursor: 'pointer', fontWeight: 600 }}>🔑 Forgot Password?</span>
                {' | '}
                <span onClick={redirectForgetUserIDPage} style={{ color: primaryRed, cursor: 'pointer', fontWeight: 600 }}>🆔 Forgot User ID?</span>
                <Divider style={{ margin: '6px 0' }} />
                <span onClick={() => setMpinChangeModal(true)} style={{ color: primaryRed, cursor: 'pointer', fontWeight: 600 }}>🔢 M-PIN</span>
                {' | '}
                <span onClick={() => setMpinChangeModal(true)} style={{ color: primaryRed, cursor: 'pointer', fontWeight: 600 }}>💳 Transaction PIN</span>
              </div>

              {/* Divider */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '20px 0', color: '#9CA3AF', fontSize: '13px' }}>
                <div style={{ flex: 1, height: '1px', background: '#E5E7EB' }}></div>
                <span>New User?</span>
                <div style={{ flex: 1, height: '1px', background: '#E5E7EB' }}></div>
              </div>

              {/* Join */}
              <button
                onClick={redirectJoinUs}
                style={btnOutlineStyle}
                onMouseOver={(e) => handleBtnHover(e, false)}
                onMouseOut={(e) => handleBtnLeave(e, false)}
              >
                ✨ Join Now - It's Free!
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />

      {/* OTP Modal */}
      {isOTPModal && (
        <Modal width={420} title={<span style={{ fontWeight: 700 }}>📱 Login Verification</span>} open={isOTPModal} footer={false}>
          <div style={{ padding: '16px 0', textAlign: 'center' }}>
            <p style={{ color: '#6B7280', marginBottom: '20px', fontSize: '14px' }}>{OTPShowMessage}</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
              <OtpInput value={otpCode} separator={<span style={{ width: '10px' }}></span>}
                onChange={(v) => setOtpCode(v)} isInputNum={true} numInputs={4} inputStyle={otpInputStyle} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
              <span style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#FFF5F5', color: primaryRed, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '15px', border: `2px solid ${primaryRed}30` }}>{timer}</span>
              <Button onClick={handleLocationClick} style={{
                flex: 1, background: `linear-gradient(135deg, ${primaryRed}, #E8454B)`,
                border: 'none', borderRadius: '12px', height: '50px', fontWeight: 700, fontSize: '15px',
                color: '#fff', boxShadow: '0 8px 25px rgba(201,38,44,0.3)'
              }}>✅ Verify OTP</Button>
            </div>
          </div>
        </Modal>
      )}

      {/* M-PIN Change */}
      {isMpinChangeModal && (
        <Modal width={420} title={<span style={{ fontWeight: 700 }}>🔢 Create M-PIN</span>} open={isMpinChangeModal} onCancel={() => setMpinChangeModal(false)} footer={false}>
          <ForgetMpin username={username.value} setMpinChangeModal={setMpinChangeModal} />
        </Modal>
      )}

      {/* Forgot Password */}
      {isForgotPasswordModal && (
        <Modal width={420} title={<span style={{ fontWeight: 700 }}>🔑 Forgot Password?</span>} open={isForgotPasswordModal} onCancel={() => setForgotPasswordModal(false)} footer={false}>
          <div style={{ padding: '10px 0' }}>
            <input type="text" {...username} placeholder="👤 User ID" style={inputStyle} maxLength={15} />
            <input type="text" placeholder="📄 Enter PAN Number" style={inputStyle} onChange={(e) => setPannumber(e.target.value)} value={isPanNumber} />
            <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
              <button onClick={() => setForgotPasswordModal(false)} style={{ ...btnOutlineStyle, flex: 1 }}>Cancel</button>
              <button onClick={checkisUserId} style={{ ...btnPrimaryStyle, flex: 1, margin: 0 }}>Confirm</button>
            </div>
          </div>
        </Modal>
      )}

      {/* Change Password */}
      {isChangePassword && (
        <Modal title={<span style={{ fontWeight: 700 }}>🔒 Change Password</span>} width={550} open={isChangePassword} onCancel={handleHideModal} footer={null}>
          <div style={{ padding: '10px 0' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#1A1A2E', display: 'block', marginBottom: '6px' }}>👤 User ID</label>
            <input type="text" {...username} style={inputStyle} readOnly />

            <label style={{ fontWeight: 600, fontSize: '13px', color: '#1A1A2E', display: 'block', marginBottom: '6px', marginTop: '14px' }}>🔒 New Password</label>
            <div style={{ position: 'relative' }}>
              <input type={showPassword ? "text" : "password"} style={inputWithIconStyle}
                onChange={(e) => changePassword(e.target.value)} value={isNewPassword} maxLength={20} />
              <div onClick={togglePasswordVisibility} style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#9CA3AF' }}>
                <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </div>
            </div>
            {strength > 0 && (
              <div className="progress m-2" style={{ height: '6px', borderRadius: '3px', background: '#F3F4F6' }}>
                <div className={getStrengthColor()} role="progressbar" style={{ width: getStrengthPercentage() + "%", borderRadius: '3px', transition: 'width 0.3s ease' }}></div>
              </div>
            )}
            <ul style={{ fontSize: '12px', lineHeight: 2, paddingLeft: '16px', marginTop: '8px' }}>
              <li className={isLowUpper ? "text-success" : "text-danger"}>✓ Lowercase & Uppercase characters</li>
              <li className={isPassNumber ? "text-success" : "text-danger"}>✓ Number (0-9)</li>
              <li className={isSpecial ? "text-success" : "text-danger"}>✓ Special Character (!@#$%^&*)</li>
              <li className={isEightPassword ? "text-success" : "text-danger"}>✓ At least 8 Characters</li>
            </ul>

            <label style={{ fontWeight: 600, fontSize: '13px', color: '#1A1A2E', display: 'block', marginBottom: '6px', marginTop: '14px' }}>✅ Confirm Password</label>
            <input type="password" style={inputStyle} onChange={(e) => setConfirmPassword(e.target.value)} value={isConfirmPassword} maxLength={20} />

            <button onClick={handleChangePasswordSendOtp} style={{ ...btnPrimaryStyle, marginTop: '16px' }}
              onMouseOver={(e) => handleBtnHover(e, true)} onMouseOut={(e) => handleBtnLeave(e, true)}>
              💾 Save Password
            </button>
          </div>
        </Modal>
      )}

      {/* Change Password OTP */}
      {isChangePasswordOTPModal && (
        <Modal width={400} title={<span style={{ fontWeight: 700 }}>📱 Mobile Verification</span>} open={isChangePasswordOTPModal} footer={false}>
          <div style={{ padding: '16px 0', textAlign: 'center' }}>
            <p style={{ color: '#6B7280', marginBottom: '20px' }}>Enter OTP sent to your registered mobile</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '24px' }}>
              <OtpInput value={otpCode} separator={<span style={{ width: '10px' }}></span>}
                onChange={(v) => setOtpCode(v)} isInputNum={true} numInputs={4} inputStyle={otpInputStyle} />
            </div>
            <button onClick={handleChangePasswordSubmit} style={btnPrimaryStyle}
              onMouseOver={(e) => handleBtnHover(e, true)} onMouseOut={(e) => handleBtnLeave(e, true)}>
              ✅ Verify & Submit
            </button>
          </div>
        </Modal>
      )}

      <Footer />
    </div>
  );
}

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = (e) => {
    if (e.target.name === "username") setValue(e.target.value.toUpperCase());
    else setValue(e.target.value);
  };
  return { value, onChange: handleChange };
};

export default Login;